import { Box, Grid } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import Title1 from "../../../../components/base/Title1";
import { usePartners } from "../../../../hooks/usePartners";

const Partners = () => {
  const { t } = useTranslation();

  const { data } = usePartners();

  if (data?.length) {
    return (
      <Box
        sx={{
          textAlign: "center",
        }}
      >
        <Title1 marginTop={20} textAlign="center">
          {t("PARTNERS")}
        </Title1>
        <Grid container spacing={3} sx={{ py: 4 }}>
          {data.map((item) => (
            <Grid item xs={6} sm={4} md={3} key={item.id}>
              <img
                style={{
                  width: "100%",
                  height: 160,
                  objectFit: "contain",
                  cursor: null !== item.attributes.url ? "pointer" : 'default',
                }}
                onClick={() => {
                  if (null !== item.attributes.url) {
                    window.open(item.attributes.url, "_blank")
                  }
                }}
                alt={item.attributes.name}
                src={item.attributes.imagePath}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }
  return null;
};

export default Partners;
